export default __webpack_public_path__ + "static/media/redo.7021ea24.svg";